var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row page-header"},[_c('div',{staticClass:"col-12 col-lg-6"},[_c('h1',[_vm._v(" "+_vm._s(_vm._f("i18n")(_vm.$route.meta.title))+" ")])]),_c('div',{staticClass:"col-12 col-lg-6"},[_c('div',{staticClass:"action-buttons"},[_vm._t("action-buttons")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }